const Heart = ({ fill_color = "#EF7969", stroke_color = "#053242", className = "" }) => (
  <svg
    className={`shrink-0 ${className}`}
    width="18"
    height="16.2191"
    viewBox="0 0 18 16.2191"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    focusable="false"
    overflow="visible"
  >
    <path
      d="M1.7448 1.7868C3.40452 0.0710678 6.09548 0.0710678 7.7552 1.7868L9 3.07359L10.2448 1.7868C11.9045 0.0710678 14.5955 0.0710678 16.2552 1.7868C17.9149 3.50253 17.9149 6.28427 16.2552 8L9 15.5L1.7448 8C0.0850679 6.28427 0.0850679 3.50253 1.7448 1.7868Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={fill_color}
      stroke={stroke_color}
      strokeLinecap="round"
    />
  </svg>
);

export default Heart;
